import NextImage from 'next/image';

import styled from 'styled-components';

import { hexToRgba } from '@/shared/modules/styled-system';

export const Wrapper = styled.a`
  display: block;
  width: 100%;
  position: relative;
  height: 0;
  padding-bottom: 58.8%;
  cursor: pointer;
`;

export const Image = styled(NextImage)`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  object-fit: cover;
`;

export const BottomContent = styled.div`
  position: absolute;
  left: 0.75rem;
  bottom: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const GameIcon = styled.img`
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 6px;
`;

export const AboveTitleText = styled.div`
  color: ${({ theme }) => hexToRgba(theme.tokens.colors.neutral[100], 0.7)};
  text-overflow: ellipsis;
  font-size: 0.8;
  font-weight: 500;
  line-height: 1rem;
`;

export const CardTitle = styled.div`
  color: ${({ theme }) => theme.tokens.colors.neutral[100]};
  text-overflow: ellipsis;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.25rem;
`;
